import {
    FETCH_AUTH_TEST, FETCH_AUTH_TEST_SUCCESS, FETCH_AUTH_TEST_FAILURE,
    FETCH_LOGIN, FETCH_LOGIN_SUCCESS, FETCH_LOGIN_FAILURE,
    FETCH_LOGOUT, FETCH_LOGOUT_SUCCESS, FETCH_LOGOUT_FAILURE,
    FETCH_FORGOT_PASSWORD, FETCH_FORGOT_PASSWORD_SUCCESS, FETCH_FORGOT_PASSWORD_FAILURE,
    FETCH_RESET_PASSWORD, FETCH_RESET_PASSWORD_SUCCESS, FETCH_RESET_PASSWORD_FAILURE, CLEAR_RESET_PASSWORD_FORM, UPDATE_RESET_PASSWORD_FORM,
    FETCH_NEW_USER, FETCH_NEW_USER_SUCCESS, FETCH_NEW_USER_FAILURE,
    CLEAR_ERROR, UPDATE_AUTH, UPDATE_CREDENTIALS, CLEAR_USER, EMPTY_AUTH, UPDATE_USER, UPDATE_USER_ADMIN_EMAIL, UPDATE_USER_ROLE
} from './constants';

const emptyUser = {
    userName: '',
    password: '',
    password2: '',
    firstName: '',
    lastName: '',
    phoneNumber: ''
};

const emptyResetPasswordForm = {
    code: '',
    password: '',
    password2: ''
};

const emptyCredentials = {
    userName: '',
    password: ''
};

const initialState = {
    credentials: JSON.parse(JSON.stringify(emptyCredentials)),
    user: JSON.parse(JSON.stringify(emptyUser)),
    adminEmail: null,
    role: null,
    resetPasswordForm: JSON.parse(JSON.stringify(emptyResetPasswordForm)),
    isTestingAuth: false,
    isLoggingIn: false,
    isLoggingOut: false,
    isPostingForgotPassword: false,
    isPostingNewUser: false,
    error: {},
    sessionTimer: null
};

function authReducer(state = initialState, action) {
    switch(action.type) {
        case FETCH_AUTH_TEST:
            return Object.assign({}, state, {
                isTestingAuth: true
            });
        case FETCH_AUTH_TEST_SUCCESS:
            return Object.assign({}, state, {
                isTestingAuth: false,
                credentials: JSON.parse(JSON.stringify(emptyCredentials))
            });
        case FETCH_AUTH_TEST_FAILURE:
            return Object.assign({}, state, {
                isTestingAuth: false,
                error: action.error
            });
        case FETCH_LOGIN:
            return Object.assign({}, state, {
                isLoggingIn: true,
                error: {}
            });
        case FETCH_LOGIN_SUCCESS:
            return Object.assign({}, state, {
                isLoggingIn: false
            });
        case FETCH_LOGIN_FAILURE:
            return Object.assign({}, state, {
                isLoggingIn: false,
                error: action.error
            });
        case FETCH_LOGOUT:
            return Object.assign({}, state, {
                isLoggingOut: true,
                error: {}
            });
        case FETCH_LOGOUT_SUCCESS:
            return Object.assign({}, state, {
                isLoggingOut: false
            });
        case FETCH_LOGOUT_FAILURE:
            return Object.assign({}, state, {
                isLoggingOut: false,
                error: action.error
            });
        case CLEAR_RESET_PASSWORD_FORM:
            return Object.assign({}, state, {
                resetPasswordForm: JSON.parse(JSON.stringify(emptyResetPasswordForm))
            });
        case UPDATE_AUTH:
            return action.data;
        case UPDATE_CREDENTIALS:
            return Object.assign({}, state, {
                credentials: action.data
            });
        case FETCH_RESET_PASSWORD:
            return Object.assign({}, state, {
                isPostingForgotPassword: true,
                error: {}
            });
        case FETCH_RESET_PASSWORD_SUCCESS:
            return Object.assign({}, state, {
                isPostingForgotPassword: false
            });
        case FETCH_RESET_PASSWORD_FAILURE:
            return Object.assign({}, state, {
                isPostingForgotPassword: false,
                error: action.error
            });
        case UPDATE_RESET_PASSWORD_FORM:
            return Object.assign({}, state, {
                resetPasswordForm: action.data
            });
        case FETCH_FORGOT_PASSWORD:
            return Object.assign({}, state, {
                isPostingForgotPassword: true,
                error: {}
            });
        case FETCH_FORGOT_PASSWORD_SUCCESS:
            return Object.assign({}, state, {
                isPostingForgotPassword: false
            });
        case FETCH_FORGOT_PASSWORD_FAILURE:
            return Object.assign({}, state, {
                isPostingForgotPassword: false,
                error: action.error
            });
        case FETCH_NEW_USER:
            return Object.assign({}, state, {
                isPostingNewUser: true,
                error: {}
            });
        case FETCH_NEW_USER_SUCCESS:
            return Object.assign({}, state, {
                isPostingNewUser: false
            });
        case FETCH_NEW_USER_FAILURE:
            return Object.assign({}, state, {
                isPostingNewUser: false,
                error: action.error
            });
        case CLEAR_ERROR:
            return Object.assign({}, state, {
                error: {}
            });
        case CLEAR_USER:
            return Object.assign({}, state, {
                user: JSON.parse(JSON.stringify(emptyUser))
            });
        case EMPTY_AUTH:
            return initialState;
        case UPDATE_USER:
            return Object.assign({}, state, {
                user: action.data
            });
        case UPDATE_USER_ADMIN_EMAIL:
            return Object.assign({}, state, {
                adminEmail: action.data
            });
        case UPDATE_USER_ROLE:
            return Object.assign({}, state, {
                role: action.data
            });
        default:
            return state;
    }
}

export default authReducer;



// WEBPACK FOOTER //
// ./src/containers/AuthPages/store/reducers.js